// src/components/PurchaseFlow/Steps/ConfirmationViews/DefaultConfirmationView.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatCurrency } from '../../../../utils/numberFormatter';
import { requiresAdvancePayment } from '../../../../utils/advancePayment';
import { 
  faFileSignature,
  faCalculator,
  faDollarSign,
  faCalendar,
  faPercentage,
  faHandHoldingUsd,
  faCalendarCheck,
  faExclamationTriangle,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

const DefaultConfirmationView = ({ 
  selectedOffer, 
  isProcessing, 
  onConfirmButtonClick,
  advancePaymentAlreadyPaid = false,
  paymentMethodsText,
  earlyPaymentText,
  latePenaltyText
}) => {
  const showAdvancePayment = requiresAdvancePayment(selectedOffer);

  const renderTextLines = (text) => (
    (text || '').split('\n').map((line) => (
      <p key={line} className="mb-0">{line}</p>
    ))
  );

  return (
    <div className="container my-5">
      <h2 className="text-center mb-2">
        <FontAwesomeIcon icon={faFileSignature} className="me-2" />
        Confirmá la venta
      </h2>
      <p className="text-center mb-4 text-muted">Revisá los detalles antes de confirmar.</p>

      <hr className="my-4" />

      <div className="row justify-content-center m-2">
        <div className="summary-section">
            <h2>
                <FontAwesomeIcon icon={faCalculator} />
                Resumen de la compra
            </h2>

            <div className="summary-item">
                <div className="summary-label">
                    <FontAwesomeIcon icon={faDollarSign} />
                    Monto de la compra
                </div>
                <div className="summary-value">{formatCurrency(selectedOffer.originalAmount, 2)}</div>
            </div>

            {showAdvancePayment && (
              <>
                <div className="summary-item">
                    <div className="summary-label">
                        <FontAwesomeIcon icon={faDollarSign} />
                        Pago inicial
                    </div>
                    <div className="summary-value">{formatCurrency(selectedOffer.downpaymentAmount, 2)} {selectedOffer.downpaymentType === 'percentage' ? `(${selectedOffer.downpaymentValue}% del monto)` : `(equivalente a ${selectedOffer.downpaymentValue} cuota${selectedOffer.downpaymentValue > 1 ? 's' : ''})`}</div>
                </div>

                <div className="summary-item">
                    <div className="summary-label">
                        <FontAwesomeIcon icon={faDollarSign} />
                        Monto a financiar
                    </div>
                    <div className="summary-value">{formatCurrency(selectedOffer.amount, 2)}</div>
                </div>

                {advancePaymentAlreadyPaid && (
                  <div className="summary-item">
                      <div className="summary-label">
                          <FontAwesomeIcon icon={faCheckCircle} />
                          Pago inicial
                      </div>
                      <div className="summary-value">Pagado con tarjeta de débito</div>
                  </div>
                )}
              </>
            )}

            <div className="summary-item">
                <div className="summary-label">
                    <FontAwesomeIcon icon={faCalendar} />
                    Cuotas
                </div>
                <div className="summary-value">{selectedOffer.term} cuotas de {formatCurrency(selectedOffer.monthlyPayment,2)}</div>
            </div>
            <div className="summary-item">
                <div className="summary-label">
                    <FontAwesomeIcon icon={faPercentage} />
                    TNA (Tasa Nominal Anual)
                </div>
                <div className="summary-value">
                  {(selectedOffer.interestRate * 100).toFixed(2)}%
                </div>
            </div>

            <div className="summary-item">
                <div className="summary-label">
                    <FontAwesomeIcon icon={faCalendar} />
                    Primer vencimiento
                </div>
                <div className="summary-value">{selectedOffer.displayDate}</div>
            </div>
        </div>
      </div>

      <div className="row justify-content-center m-2">
        <div className="terms-section">
            <div className="terms-item">
                <div className="terms-icon text-primary">
                    <FontAwesomeIcon icon={faHandHoldingUsd} />
                </div>
                <div>
                    <h6 className="mb-1 mt-1">Cómo cobramos</h6>
                    {renderTextLines(paymentMethodsText)}
                </div>
            </div>

            <div className="terms-item">
                <div className="terms-icon text-primary">
                    <FontAwesomeIcon icon={faCalendarCheck} />
                </div>
                <div>
                <h6 className="mb-1 mt-1">Si querés pagar antes</h6>
                    <p>{earlyPaymentText}</p>
                </div>
            </div>
            <div className="terms-item">
                <div className="terms-icon text-primary">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
                <div>
                  <h6 className="mb-1 mt-1">Si se atrasa el pago</h6>
                  <p>{latePenaltyText}</p>
                </div>
            </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <button 
          className="btn btn-primary btn-lg" 
          onClick={onConfirmButtonClick}
          disabled={isProcessing}
        >
          {isProcessing ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Procesando...
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
              {showAdvancePayment && !advancePaymentAlreadyPaid
                ? 'Cobrá el pago inicial y confirmá'
                : 'Confirmá la venta'}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default DefaultConfirmationView;
